import { BaseBus } from './BaseBus';

export class AssignTechDispatchBus extends BaseBus
{
  CID(): any {
    return this.dispatchId;
  }
    constructor(data: AssignTechDispatchBus) {
    super(data);
  }
    dispatchId: any;
    customerId: any;
    locationId: any;
    dispatchNumber: string;
    dispatchReason: string;
    dispatchStatus: string;
    dispatchStatusId: any;
    accountClassId: any;
    priorityId: any;
}
